<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <g clip-path="url(#fido-passkey__a)" fill="currentColor"
      ><path
        d="m9.583 11.19.044.007c.322 0 .645 0 .966.004a18.353 18.353 0 0 1 .274-.054c1.094-.223 1.96-.792 2.456-1.854.478-1.016.525-2.089.208-3.162-.314-1.064-.992-1.79-2.004-2.166-.672-.25-1.368-.278-2.067-.153-1.168.21-2.057.832-2.553 1.979-.35.806-.42 1.66-.271 2.522.217 1.26.89 2.152 2.043 2.636.291.124.596.182.904.24Z" /><path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.826 7.882c1.745.465 3.034 2.116 3.034 4.082 0 1.816-1.1 3.364-2.644 3.956l.871 1.568.008.012-.03.036-1.269 1.696 1.295 1.691.004.005-.276.37L18.823 24v-.023l-1.602-1.709v-6.461c-1.424-.647-2.42-2.13-2.42-3.855 0-2.32 1.8-4.2 4.022-4.201l1.003.13Zm-1.003 4.713c.536 0 .97-.455.97-1.014 0-.56-.434-1.014-.97-1.014-.535 0-.97.453-.97 1.014-.001.56.435 1.013.97 1.014Z" /><path
        d="m19.826 7.882-1.002-.131h.001c.346 0 .68.045 1 .13Zm-3.922 8.688c-1.3-1.066-2.173-2.706-2.293-4.569H6.645C5.184 12.001 4 13.203 4 14.685v3.356c0 .742.592 1.343 1.323 1.343h9.258c.731 0 1.323-.601 1.323-1.343v-1.47Z" /></g
    ><defs><clipPath id="fido-passkey__a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath></defs>
  </g>
</svg>
